const loadHistory = {};

export const load = ({url}) => new Promise(((resolve) => {
    if (loadHistory[url]) {
        resolve();
    } else {
        const firstScript = document.getElementsByTagName('script')[0];
        const s = document.createElement('script');
        const protocol = document.location.protocol === 'https:' ? ' https:' : ' http:';
        s.type = 'text/javascript';
        s.async = false;
        s.onload = function() {
            loadHistory[url] = true;
            resolve();
        };
        s.src = `${protocol}${url}?${+new Date(new Date().setHours(0, 0, 0, 0))}`;
        firstScript.parentNode.insertBefore(s, firstScript);
    }
}));

export const load58AppSDK = () => new Promise((reslove) => {
    if (typeof window.WBAPP !== 'object') {
        load({url: '//a.58cdn.com.cn/app58/rms/app/js/app_30805.js'}).then(() => {
            reslove();
        });
    } else {
        reslove();
    }
});
